import $api from "../../axios"
import {AppDispatch} from "../index"
import {IEmployee, IEmployeePayload, IFetchEmployeesParams} from "../../models/employee"
import {employeeSlice} from "../slices/employeeSlice"

export const fetchEmployees = (params: IFetchEmployeesParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(employeeSlice.actions.fetching())
    const response = await $api.get<IEmployeePayload>("employee/employee/index", {
      params
    })
    dispatch(employeeSlice.actions.fetchSuccess(response.data))
  } catch (e: any) {
    dispatch(employeeSlice.actions.fetchError(e))
  }
}

export const addEmployee = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(employeeSlice.actions.creating())
    const response = await $api.post<IEmployee>("employee/employee/add", data)
    dispatch(employeeSlice.actions.createSuccess(response.data))
    return response.data.id
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(employeeSlice.actions.saveFieldError(e.response.data))
    } else {
      dispatch(employeeSlice.actions.creationError(e))
    }
  }
}

export const updateEmployee = (data: object) => async(dispatch: AppDispatch) => {
  try {
    dispatch(employeeSlice.actions.updating())
    await $api.put<IEmployee>("employee/employee/update", data)
    dispatch(employeeSlice.actions.updateSuccess())
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(employeeSlice.actions.saveFieldError(e.response.data))
    } else {
      dispatch(employeeSlice.actions.updateError(e))
    }
  }
}

export const clearEmployees = () => (dispatch: AppDispatch) => {
  dispatch(employeeSlice.actions.clear())
}

export const deleteEmployee = (user_uuid: string) => async (dispatch: AppDispatch) => {
  try {
    await $api.delete("employee/employee/delete", {
      params: {
        user_uuid
      }
    })
    return true
  } catch (e:any) {
    console.log(e)
  }
}

export const setCurrentPage = (pageNumber: number) => (dispatch: AppDispatch) => {
  dispatch(employeeSlice.actions.setCurrentPage(pageNumber))
}
